function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import digitalData from 'digital-data';
import { BROWSE, SEARCH, FILTER } from '../constants.js';
import { getState, setState } from '../analytics-state.js';
import { getCategoryBreadCrumbs, getHeaderCrumb } from '../thd-analytics-utils.js';
export const getFiltersRefinementsAnalytics = _ref => {
  var _sortBy;
  let {
    breadCrumbs,
    searchReport = {},
    pageFilters = []
  } = _ref;
  let {
    sortOrder = '',
    sortBy,
    startIndex,
    keyword
  } = searchReport || {};
  const pageNumber = startIndex / 24 + 1;
  const {
    filters = []
  } = getState();
  const digitalDataPages = digitalData === null || digitalData === void 0 ? void 0 : digitalData.page.displayAttributes;
  digitalData.page.category = getCategoryBreadCrumbs(breadCrumbs) || {};
  if (!digitalData.page.category.headerCrumb) {
    var _breadCrumbs$;
    const categoryCrumb = breadCrumbs !== null && breadCrumbs !== void 0 && (_breadCrumbs$ = breadCrumbs[0]) !== null && _breadCrumbs$ !== void 0 && _breadCrumbs$.dimensionName ? breadCrumbs.filter(crumb => (crumb === null || crumb === void 0 ? void 0 : crumb.dimensionName.toLowerCase()) === 'category') : breadCrumbs;
    digitalData.page.category.headerCrumb = getHeaderCrumb(categoryCrumb);
  }
  function filterItems() {
    let crumbs = [];
    if (pageFilters.length) {
      crumbs = (breadCrumbs || []).filter(crumb => {
        const {
          dimensionName,
          label
        } = crumb;
        return pageFilters.some(pageFilter => {
          const {
            type,
            value
          } = pageFilter;
          return (type === null || type === void 0 ? void 0 : type.toLowerCase()) === (dimensionName === null || dimensionName === void 0 ? void 0 : dimensionName.toLowerCase()) && (value === null || value === void 0 ? void 0 : value.toLowerCase()) === (label === null || label === void 0 ? void 0 : label.toLowerCase());
        });
      });
    } else if (filters.length > 0) {
      crumbs = filters;
    } else {
      crumbs = (breadCrumbs || []).filter(crumb => {
        return (crumb === null || crumb === void 0 ? void 0 : crumb.deselectUrl) && (crumb === null || crumb === void 0 ? void 0 : crumb.dimensionName);
      });
    }
    const selectedFilters = [];
    crumbs.forEach(function () {
      var _crumb$dimensionName, _crumb$label;
      let crumb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      let index = arguments.length > 1 ? arguments[1] : undefined;
      if (!(crumb !== null && crumb !== void 0 && crumb.dimensionName)) return;
      const lowercaseDimensionLabel = crumb === null || crumb === void 0 ? void 0 : (_crumb$dimensionName = crumb.dimensionName) === null || _crumb$dimensionName === void 0 ? void 0 : _crumb$dimensionName.toLowerCase();
      const lowercaseRefinementLabel = crumb === null || crumb === void 0 ? void 0 : (_crumb$label = crumb.label) === null || _crumb$label === void 0 ? void 0 : _crumb$label.toLowerCase();
      const refinementIndex = (crumb === null || crumb === void 0 ? void 0 : crumb.refinementIndex) || null;
      selectedFilters.push({
        type: lowercaseDimensionLabel,
        value: lowercaseRefinementLabel,
        position: crumb.position || `left rail:${lowercaseDimensionLabel}:${refinementIndex || index + 1}`,
        selectionMethod: crumb.selectionMethod || 'all'
      });
    });
    return selectedFilters;
  }
  switch ((_sortBy = sortBy) === null || _sortBy === void 0 ? void 0 : _sortBy.toUpperCase()) {
    case 'PRICE':
      if (sortOrder.toUpperCase() === 'ASC') {
        sortBy = 'price low to high';
      } else if (sortOrder.toUpperCase() === 'DESC') {
        sortBy = 'price high to low';
      }
      break;
    case 'MOSTPOPULAR':
      sortBy = 'most popular';
      break;
    case 'TOPSELLERS':
      sortBy = 'top sellers';
      break;
    case 'TOPRATED':
      sortBy = 'top rated products';
      break;
    case 'BESTMATCH':
      sortBy = 'best match';
      break;
    default:
      sortBy = '';
  }
  const ddoEvent = {
    category: {
      primaryCategory: keyword ? SEARCH : BROWSE
    },
    displayAttributes: {
      pageNumber,
      productsAvailability: digitalDataPages ? digitalDataPages === null || digitalDataPages === void 0 ? void 0 : digitalDataPages.productsAvailability : 'in store',
      sortBy,
      viewType: digitalDataPages ? digitalDataPages === null || digitalDataPages === void 0 ? void 0 : digitalDataPages.viewType : 'grid'
    },
    eventInfo: {
      eventName: 'filter by'
    },
    filter: filterItems() || [],
    isReported: true,
    sourceIndex: 0
  };
  return ddoEvent;
};
export const filtersAndRefinements = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('filters-refinements.publish', _ref2 => {
    let {
      output = {}
    } = _ref2;
    digitalData.event.push(getFiltersRefinementsAnalytics(output));
  });
  window.LIFE_CYCLE_EVENT_BUS.on('filters-refinements.click', function (_ref3) {
    let {
      output = {}
    } = _ref3;
    let {
      filters = []
    } = getState();
    if (output !== null && output !== void 0 && output.clear) {
      filters = [];
    } else if (output !== null && output !== void 0 && output.dimensionName && filters.findIndex(filter => filter.label === (output === null || output === void 0 ? void 0 : output.label)) === -1) {
      filters.push(output);
    } else {
      filters = filters.filter(filter => filter.label !== (output === null || output === void 0 ? void 0 : output.label));
    }
    setState(_objectSpread(_objectSpread({}, getState()), {}, {
      pageTransitionEvent: FILTER,
      filters
    }));
  });
};
//# sourceMappingURL=filter-refinements.listener.analytics.js.map